/**
 * Sign Up Route
 * Public route for user registration
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { SignUpPage } from '../pages/Auth/SignUpPage'
import { requireGuest } from '../router/guards'
import { useAuth } from '../hooks/useAuth'
import { SignUpData } from '../types/auth.types'

// Signup route component with navigation handlers
const SignUpRouteComponent = () => {
  const navigate = useNavigate()
  const { signUp, signInWithGoogle } = useAuth()

  const handleSignUp = async (data: SignUpData) => {
    if (!signUp) {
      console.error('signUp function is not available')
      return
    }

    await signUp({
      email: data.email,
      password: data.password,
      firstName: data.firstName,
      lastName: data.lastName,
      phone: data.phone,
      acceptedTerms: data.acceptedTerms,
    })

    navigate({
      to: '/email-verification',
      search: { email: data.email },
    })
  }

  return (
    <SignUpPage
      onSignUp={handleSignUp}
      onLogin={() => navigate({ to: '/login' })}
      onGoogleSignUp={async () => {
        if (signInWithGoogle) {
          await signInWithGoogle()
        }
      }}
    />
  )
}

// Create signup route with guest guard
export const Route = createFileRoute('/signup')({
  beforeLoad: requireGuest,
  component: SignUpRouteComponent,
})
